// extracted by mini-css-extract-plugin
export var actionButton = "_ij-0";
export var fileInput = "_ij-2";
export var paperclip = "_ij-1";